export const getRandomColor = (name) => {
    // 基于名字生成稳定的颜色，同样的名字总是生成同样的颜色
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
   
    const colors = [
      '#4285F4', // 蓝色
      '#34A853', // 绿色
      '#FBBC05', // 黄色
      '#EA4335', // 红色
      '#8F44AD', // 紫色
      '#16A085', // 绿松石色
      '#F39C12', // 橙色
      '#7F8C8D', // 灰色
      '#3498DB', // 浅蓝色
      '#2ECC71'  // 浅绿色
    ];
    
    return colors[Math.abs(hash) % colors.length];
  };